export const handleKeyboardNavigation = (
  e,
  currentIndex,
  handleOnClick,
  setShowResults,
  results,
  key,
  resultsListId,
  resultsItemId
) => {
  if (key === 40) {
    onArrowDown(e, currentIndex, resultsItemId, results);
  } else if (key === 38) {
    onArrowUp(e, currentIndex, resultsItemId);
  } else if (key === 27) {
    onEscape(setShowResults, resultsListId);
  } else if (key === 32) {
    onSpaceBar(e, resultsListId, handleOnClick, setShowResults);
  }
};

const onArrowUp = (e, currentIndex, resultsItemId) => {
  if (currentIndex > 0) {
    e.preventDefault();
    document.getElementById(`${resultsItemId}_${currentIndex - 1}`).focus();
  }
};

const onArrowDown = (e, currentIndex, resultItemId, results) => {
  if (currentIndex < results.length) {
    e.preventDefault();
    document.getElementById(`${resultItemId}_${currentIndex + 1}`).focus();
  }
};

const onSpaceBar = async (e, resultsListId, handleOnClick, setShowResults) => {
  if (handleOnClick) {
    e.preventDefault();
    document.getElementById(resultsListId).focus();
    await handleOnClick();
    setShowResults(false);
  }
};

const onEscape = (setShowResults, resultsListId) => {
  setShowResults(false);
  document.getElementById(resultsListId).focus();
};
